import { createFileRoute } from '@tanstack/react-router'
import { LifecycleEventEditor } from './-LifecycleEventEditor'

// ModuleGuard komt van de lifecycle-route.tsx layout — geen wikkel per pagina.
export const Route = createFileRoute('/hr/lifecycle/$id')({
  component: LifecycleEventDetail,
})

function LifecycleEventDetail() {
  const { id } = Route.useParams()
  return <LifecycleEventEditor id={id} />
}
